"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalZip = void 0;
const react_1 = __importStar(require("react"));
const components_core_1 = require("@volkswagen-onehub/components-core");
const is_browser_1 = __importDefault(require("is-browser"));
const icons_core_1 = require("@volkswagen-onehub/icons-core");
const modal_zip_container_1 = require("./modal-zip-container");
const styled_1 = require("./styled");
const text_custom_1 = require("../text-custom");
const typing_1 = require("../text-custom/typing");
const disable_focus_container_1 = require("../disable-focus-container");
const button_1 = require("../button");
const input_zip_1 = __importDefault(require("../input-zip"));
exports.ModalZip = react_1.default.memo((props) => {
    const { active, zipManager, translations, validateZipQuery, privacyContentLink, useZipData, trackingErrorCallback, trackingClickCallback } = props;
    const childRef = (0, react_1.useRef)();
    (0, react_1.useEffect)(() => {
        if (is_browser_1.default) {
            if (active) {
                document.body.style.overflow = 'hidden';
            }
            else {
                document.body.style.overflow = 'inherit';
            }
        }
        return () => {
            if (is_browser_1.default) {
                document.body.style.overflow = 'inherit';
            }
        };
    }, [active]);
    const onHandlePrivacyLink = () => {
        trackingClickCallback && trackingClickCallback();
    };
    return (react_1.default.createElement(styled_1.ModalZipWrapper, { className: "modal-zip__wrapper" },
        react_1.default.createElement(modal_zip_container_1.ModalZipContainer, { active: active },
            react_1.default.createElement(styled_1.StyledZipContainerGroup, { className: "container-group" },
                react_1.default.createElement(styled_1.StyledHeaderContainer, { className: "header__container" },
                    react_1.default.createElement(icons_core_1.FindCar, { ariaLabel: 'Find car', variant: "large" }),
                    react_1.default.createElement(text_custom_1.TextCustom, { appearance: components_core_1.TokenTextAppearance.headline200, style: {
                            [components_core_1.Breakpoints.default]: {
                                fontSize: typing_1.TextSize.TextSize32,
                                fontWeight: typing_1.TextWeight.bold
                            },
                            [components_core_1.Breakpoints.b560]: {
                                fontSize: typing_1.TextSize.TextSize48
                            }
                        } }, translations.title)),
                react_1.default.createElement(styled_1.StyledSubHeaderContainer, { className: "subheader__container" },
                    react_1.default.createElement(text_custom_1.TextCustom, { appearance: components_core_1.TokenTextAppearance.headline200, style: {
                            [components_core_1.Breakpoints.default]: {
                                fontSize: typing_1.TextSize.TextSize20,
                                textAlign: components_core_1.TextAlignment.center
                            },
                            [components_core_1.Breakpoints.b560]: {
                                fontSize: typing_1.TextSize.TextSize24
                            }
                        } }, translations.description)),
                react_1.default.createElement(styled_1.StyledButtonGroupWrapper, { className: "button-group__wrapper" },
                    react_1.default.createElement(styled_1.StyledButtonGroupContainer, { className: "button-group__container" },
                        react_1.default.createElement(input_zip_1.default, { placeholder: translations.inputMessage.placeholder, label: translations.inputMessage.label, errorText: translations.inputMessage.error, maxLength: 5, ref: childRef, isDefault: true, zipManager: zipManager, validateZipQuery: validateZipQuery, trackingErrorCallback: trackingErrorCallback, useZipData: useZipData }),
                        react_1.default.createElement(styled_1.StyledButtonContainer, { className: "button__container" },
                            react_1.default.createElement(disable_focus_container_1.DisableFocusContainer, null,
                                react_1.default.createElement(button_1.Button, { appearance: button_1.ButtonAppearance.Primary, onClick: () => childRef.current.applyZip(), stretchContent: true },
                                    react_1.default.createElement(components_core_1.Text, { color: components_core_1.TokenTextColor.inherit, appearance: components_core_1.TokenTextAppearance.copy100 }, translations.goCtaLabel)))))),
                react_1.default.createElement(components_core_1.Text, { appearance: components_core_1.TokenTextAppearance.copy100, tag: components_core_1.TextTag.div, bold: true, textAlign: components_core_1.TextAlignment.center },
                    react_1.default.createElement(disable_focus_container_1.DisableFocusContainer, null,
                        react_1.default.createElement(components_core_1.CTA, { tag: "a", target: "_blank", emphasis: "tertiary", href: privacyContentLink, ariaLabel: "aria label", onClick: onHandlePrivacyLink }, translations.privacyLinkCta)))))));
}, (prevProps, nextProps) => prevProps.active === nextProps.active);
